<template>
<card class="container w-full mx-auto mt-5">
    <template #header><h4 v-if="!loading" class="text-uppercase text-center mb-0">
            {{ topic.translation ? topic.translation.title : ''}}
        </h4></template>
    <loading-spinner v-if="loading" />
    <template v-else>
        <h4 class="text-center mb-3">
            {{ topic.translation ? topic.translation.description : ''}}
        </h4>
        <submit-success view v-if="topic.answered" />
        <template v-else-if="showResult">
            <base-progress
                v-for="option in topic.options"
                :key="option.id"
                show-label
                type="success"
                :height="8"
                :value="checkTotalPercent(topic.total, option.selections)"
                :label="option.translation.name"
            />
        </template>
        <template v-else>
            <form role="form">
                <div v-if="topic.type !== 4" class="control ml-4 mb-4">
                    <div
                        v-for="(option, i) in topic.options"
                        :key="option.id"
                        class="mt-2 custom-control custom-radio">
                        <div>
                            <input
                                type="radio"
                                v-model="answer"
                                :value="option.translation.option_id"
                                :id="option.translation.option_id"
                                :name="`survey-option-${i}`" class="custom-control-input"
                            >
                            <label class="custom-control-label" :for="option.translation.option_id">
                                <span v-html="optionLabel(topic.type, option.translation.slug, option.translation.name, option.icon)"/>
                            </label>
                        </div>
                    </div>
                </div>
                <topic-satisfaction-grade
                    v-else-if="topic.type === 4"
                    :topic="topic"
                    v-model="answer"
                />
                <base-input
                    v-if="topic.justify_answer"
                    :label="$t('common.justify_answer')"
                    :error="errors.first($t('common.justify_answer'))"
                >
                    <textarea
                        v-validate="'required|min:6'"
                        v-model="justify"
                        :name="$t('common.justify_answer')"
                        class="form-control"
                        id="exampleFormControlTextarea3" rows="2"
                    />
                </base-input>
            </form>
        </template>
    </template>
    <template #footer>
        <div class="w-100 d-flex justify-content-between">
            <base-button v-if="!topic.answered && !submited" type="primary" @click="submit">
                {{$t('common.send')}}
            </base-button>
        </div>
    </template>
</card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import NavigationControl from '../../../components/Common/NavigationControl';
import LoadingSpinner from '../../../components/Common/LoadingSpinner';
import SubmitSuccess from '../../../components/Common/SubmitSuccess';

import BaseModal from '../../../argon/components/Modal';
import BaseButton from '../../../argon/components/BaseButton';
import BaseProgress from '../../../argon/components/BaseProgress';
import BaseInput from '../../../argon/components/Inputs/BaseInput';
import Card from '../../../argon/components/Cards/Card';

import TopicSatisfactionGrade from './../../Common/TopicComponents/TopicSatisfactionGrade';

export default {
    name: 'ClassTopic',
    components: {
        BaseModal,
        BaseButton,
        LoadingSpinner,
        SubmitSuccess,
        BaseProgress,
        BaseInput,
        NavigationControl,
        Card,
        TopicSatisfactionGrade,
    },
    data() {
        return {
            modal: true,
            loading: false,
            submited: false,
            showResult: false,
            justify: '',
            answer: '',
        };
    },
    watch: {
        topic(value, oldValue) {
            if (value !== oldValue) {
                this.topic = value;
            }
        },
    },

    computed: mapGetters({
        color: 'COLOR',
        topic: 'CLASS_TOPIC',
        course: 'CLASS_COURSE',
    }),

    methods: {
        ...mapActions({ submitTopic: 'CLASS_TOPIC_SUBMIT' }),
        optionLabel(type, slug, name, icon) {
            const count = slug[0];
            const starRating = '<i class="survey-star-rating mdi mdi-star"></i>';
            switch (type) {
            case 1:
                return name;
            case 2:
                if (count == 1) return starRating.repeat(count);
                if (count == 2) return starRating.repeat(count);
                if (count == 3) return starRating.repeat(count);
                if (count == 4) return starRating.repeat(count);
                if (count == 5) return starRating.repeat(count);
                break;
            case 3:
                if (icon == 5) return `<i class="nch-topic-rating mdi mdi-emoticon-angry-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                if (icon == 4) return `<i class="nch-topic-rating mdi mdi-emoticon-sad-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                if (icon == 3) return `<i class="nch-topic-rating mdi mdi-emoticon-neutral-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                if (icon == 2) return `<i class="nch-topic-rating mdi mdi-emoticon-happy-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                if (icon == 1) return `<i class="nch-topic-rating mdi mdi-emoticon-excited-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                break;

            default:
                break;
            }
        },
        submit() {
            if (!this.answer) {
                this.$notify({
                    type: 'danger',
                    message: this.$t('common.select_one'),
                });
                return;
            }
            this.$validator.validate()
                .then(async (valid) => {
                    if (valid) {
                        this.loading = true;
                        await this.submitTopic({
                            justify: this.justify,
                            answer: this.answer,
                            // topic.link_course é flag boolean, não id — usava
                            // Course::find(bool) no backend e falhava silenciosamente
                            parents: {courseId: this.course && this.course.id},
                        })
                            .then(() => {
                                this.showResult = true;
                                this.submited = true;
                                this.$emit('submited');
                            })
                            .catch((err) => {
                                console.error(err);
                                this.showResult = false;
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                });
        },
        checkTotalPercent(total, selections) {
            const res = selections / total * 100;
            return Math.round((res + Number.EPSILON) * 100) / 100;
        },
    },
};
</script>

<style>
.survey-star-rating {
    color: #e6e61a;
    font-size: 1.2rem
}

.nch-topic-rating {
    font-size: 1.7rem;
    position: absolute;
    top: -10px;
}

.nch-topic-rating--text {
    font-size: .9rem;
    margin-left: 2.7rem;
}

.w-full {
    width: 100%;
}
</style>
